export interface AnalyticsClient {
  capture: (event: string, properties?: Record<string, unknown>) => unknown
  captureException: (error: unknown, properties?: Record<string, unknown>) => unknown
  identify: (id: string, properties?: Record<string, unknown>) => unknown
  group: (type: string, key: string, properties?: Record<string, unknown>) => unknown
  reset: () => unknown
}

const noop: AnalyticsClient = {
  capture: () => undefined,
  captureException: () => undefined,
  identify: () => undefined,
  group: () => undefined,
  reset: () => undefined,
}

let client: AnalyticsClient = noop
export const setAnalyticsClient = (next?: AnalyticsClient | null) => {
  client = next ?? noop
}
export const analytics: AnalyticsClient = {
  capture: (...args) => client.capture(...args),
  captureException: (...args) => client.captureException(...args),
  identify: (...args) => client.identify(...args),
  group: (...args) => client.group(...args),
  reset: () => client.reset(),
}
